import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M9 2C4.029 2 0 5.134 0 9s4.029 7 9 7 9-3.134 9-7-4.029-7-9-7zm2.855 12.405c-1.8.425-4.113.349-5.652-.023C4.227 13.904 1.978 12.86 2 10.581c.022-2.236 2.718-3.888 8.034-3.888v-4C12.642 2.693 16 5.346 16 9c0 3.273-2.158 4.936-4.145 5.405zm-6.57-3.491c0 1.799 2.089 3.258 4.665 3.258V7.656c-2.576 0-4.665 1.459-4.665 3.258z" />
  </svg>
);

export default SvgComponent;
